<div class="vilc-wrapper">
  <div class="content-header">
    <span class="header-text">VILC Opportunities</span>
    <div class="action-icons">
      <img
        (click)="openVilcGuideDialog()"
        src="assets/images/vilc-opp-info.svg"
        alt="EditVilcOpportunity"
      />
      <img
        (click)="openModifyDialog()"
        src="assets/images/edit-gray.svg"
        alt="financially_viableYes"
      />
    </div>
  </div>
  <div class="table-card">
    <table class="vilc-table">
      <thead>
        <tr>
          <th>SKU Name</th>
          <th>Segment</th>
          <th>Brand</th>
          <th>Volume(1yr)</th>
          <th>MACO/HL</th>
          <th>MACO/HL Threshold</th>
          <th>MACO/HL Segment</th>
          <th style="min-width: 120px">VILC/HL</th>
          <th>VILC/HL Index</th>
          <th>Can VILC/HL Be <br />Improved?</th>
          <th>If Yes, Do You Have <br />New VILC/HL Value?</th>
          <th>Enter Revised VILC/HL</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="paginatedRows.length === 0">
          <td colspan="12" class="empty-message">
            No opportunities available.
          </td>
        </tr>
        <tr
          *ngFor="let r of paginatedRows; trackBy: trackByIndex"
          class="vilc-row"
        >
          <td data-label="SKU Name">
            <div class="sku">{{ r.sku_detail || "-" }}</div>
          </td>
          <td data-label="Segment">{{ r.ptc_segment || "-" }}</td>
          <td data-label="Brand">{{ r.brand || "-" }}</td>
          <td data-label="Volume(1yr)">{{ r.volume || "-" }}</td>
          <td data-label="MACO/HL">{{ r.maco_hl || "-" }}</td>
          <td data-label="MACO/HL Threshold">
            {{ r.maco_hl_threshold || "-" }}
          </td>
          <td data-label="MACO/HL Segment">{{ r.maco_hl_segment || "-" }}</td>
          <td data-label="VILC/HL" style="min-width: 120px">
            <div class="with-warning">
              {{ r.vilc_hl }}
              <img src="assets/images/caution-yellow.svg" alt="CautionYellow" />
            </div>
          </td>
          <td data-label="VILC/HL Index">{{ r.vilc_index || "-" }}</td>
          <td data-label="Financially Viable">
            <div class="viable-controls">
              <ng-container
                *ngIf="
                  r.financially_viable === null ||
                  r.financially_viable === undefined
                "
              >
                <img
                  (click)="setViable(r, true)"
                  src="assets/images/white-tick-green-background.svg"
                  alt="Yes"
                />
                <img
                  (click)="setViable(r, false)"
                  src="assets/images/white-cross-red-background.svg"
                  alt="No"
                />
              </ng-container>
              <ng-container *ngIf="r.financially_viable === true">
                <img
                  src="assets/images/financially-viable-yes.svg"
                  alt="financially_viableYes"
                  class="viable-status"
                />
                <img
                  (click)="startEdit(r)"
                  src="assets/images/edit-gray.svg"
                  alt="financially_viableEdit"
                  class="gray-icon"
                />
              </ng-container>
              <ng-container *ngIf="r.financially_viable === false">
                <img
                  src="assets/images/financially-viable-no.svg"
                  alt="financially_viableNo"
                  class="viable-status"
                />
                <img
                  (click)="startEdit(r)"
                  src="assets/images/edit-gray.svg"
                  alt="financially_viableEdit"
                  class="gray-icon"
                />
              </ng-container>
            </div>
          </td>
          <td data-label="Have new value">
            <div class="viable-controls">
              <ng-container *ngIf="r.financially_viable === true; else dash">
                <ng-container
                  *ngIf="
                    r.have_new_value === null || r.have_new_value === undefined
                  "
                >
                  <img
                    (click)="sethave_new_value(r, true)"
                    src="assets/images/white-tick-green-background.svg"
                    alt="Yes"
                  />
                  <img
                    (click)="sethave_new_value(r, false)"
                    src="assets/images/white-cross-red-background.svg"
                    alt="No"
                  />
                </ng-container>
                <ng-container *ngIf="r.have_new_value === true">
                  <img
                    src="assets/images/financially-viable-yes.svg"
                    alt="have_new_valueYes"
                    class="viable-status"
                  />
                  <img
                    (click)="sethave_new_value(r, null)"
                    src="assets/images/edit-gray.svg"
                    alt="have_new_valueEdit"
                    class="gray-icon"
                  />
                </ng-container>
                <ng-container *ngIf="r.have_new_value === false">
                  <img
                    src="assets/images/financially-viable-no.svg"
                    alt="have_new_valueNo"
                    class="viable-status"
                  />
                  <img
                    (click)="sethave_new_value(r, null)"
                    src="assets/images/edit-gray.svg"
                    alt="have_new_valueEdit"
                    class="gray-icon"
                  />
                </ng-container>
              </ng-container>
              <ng-template #dash>-</ng-template>
            </div>
          </td>
          <td data-label="New VILC">
            <div
              *ngIf="
                r.financially_viable === true && r.have_new_value === true;
                else dash
              "
            >
              <input
                type="text"
                inputmode="decimal"
                pattern="[0-9.-]*"
                [value]="r.new_vilc_hl"
                (keypress)="restrictToNumeric($event)"
                (input)="onnew_vilc_hlChange(r, $any($event.target).value)"
                placeholder="Enter value"
                class="new-vilc-input"
              />
            </div>
            <ng-template #dash>-</ng-template>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="table-footer">
      <div class="footer-left">
        <label>
          Items per page
          <select [(ngModel)]="pageSize" (change)="onPageSizeChange($event)">
            <option *ngFor="let size of pageSizes" [value]="size">
              {{ size }}
            </option>
          </select>
        </label>
        <span
          >{{ startIndex + 1 }}–{{ endIndex }} of {{ totalItems }} entries</span
        >
      </div>
      <div class="footer-right">
        <button (click)="prevPage()" [disabled]="currentPage === 1">‹</button>
        <span>
          Page
          <input
            type="number"
            [(ngModel)]="currentPage"
            (change)="onPageInputChange($event)"
            class="page-input"
            [min]="1"
            [max]="totalPages"
          />
          of {{ totalPages }}
        </span>
        <button (click)="nextPage()" [disabled]="currentPage === totalPages">
          ›
        </button>
      </div>
    </div>
    <div class="simulate-button">
      <app-button-primary
        buttonCaption="Simulate"
        [buttonDisabled]="isSimulationDisabled"
        (actionButtonCall)="onSimulate()"
      ></app-button-primary>
    </div>
  </div>
</div>

<p-dialog
  [(visible)]="showVilcGuideDialog"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="vilc-guide-dialog"
  header="Stepwise Guide to Optimize SKUs Actions Flow"
  [style]="{ width: 'auto' }"
>
  <div class="dialog-content">
    <!-- Step 1 -->
    <div class="image-wrapper" *ngIf="currentStep === 1">
      <img src="assets/images/vilc-opp-guide-step-1.png" alt="Step 1" />
      <div class="step-one-section">
        <div class="step-header">Step 1: VILC Opportunity Assessment</div>
        <div class="step-text">Identify if the SKU has a VILC Opportunity</div>
        <div class="step-text">
          If Financially viable provide the new VILC value
        </div>
        <div class="step-text">If not, no value is required</div>
        <div class="step-text">
          Though its viable and the value is not known,<br />
          have the field empty.
        </div>
        <div class="button-section">
          <button class="next-button" (click)="nextStep()">Next</button>
        </div>
      </div>
    </div>

    <!-- Step 2 -->
    <div class="image-wrapper" *ngIf="currentStep === 2">
      <img src="assets/images/vilc-opp-guide-step-2.png" alt="Step 2" />
      <div class="step-two-section">
        <div class="step-header">Step 2: Profitability Check</div>
        <div class="step-text">
          System validates profitability using the rule:
        </div>
        <div class="step-rule">New MACO > MACO Threshold constraints</div>
        <div class="button-section">
          <button class="back-button" (click)="prevStep()">Back</button>
          <button class="next-button" (click)="nextStep()">Next</button>
        </div>
      </div>
    </div>

    <!-- Step 3 -->
    <div class="image-wrapper" *ngIf="currentStep === 3">
      <img src="assets/images/vilc-opp-guide-step-3.png" alt="Step 3" />
      <div class="step-three-section">
        <div class="step-header">Step 3: Cannibalization & PINC Analysis</div>
        <div class="step-text">
          For SKUs without a VILC opportunity and not <br />a megabrand.
        </div>
        <div class="step-text">
          System checks if SKU is high volume retention <br />then provide the
          recommendation accordingly
        </div>
        <div class="step-text">
          If not, system checks for a PINC Opportunity using:
        </div>
        <div class="step-rule">Net Revenue > Net Revenue Index</div>
        <div class="button-section">
          <button class="back-button" (click)="prevStep()">Back</button>
          <button class="next-button" (click)="finish()">Proceed</button>
        </div>
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog
  header="Modify"
  [(visible)]="showModifyDialog"
  [style]="{ width: '30vw' }"
  [modal]="true"
  styleClass="modify-dialog"
  [draggable]="false"
>
  <div>
    <div class="flex justify-between mb-2">
      <p class="upload-label">Upload Edited Data</p>
      <span
        class="download-temp flex items-center"
        [ngClass]="
          fileUploadContent.downloadSpinner
            ? 'cursor-default pointer-events-none	'
            : ''
        "
        (click)="onDownloadResults()"
      >
        <span class="dowload-temp-label">Download Data</span>
      </span>
    </div>
    <app-upload-file
      [uploadDataContent]="fileUploadContent"
      (actionBrowseButtonCall)="onFileBrowse($event)"
      (actionFileDropCall)="onFileDrop($event)"
      (actionCancelCall)="onFileUploadCancel($event)"
    ></app-upload-file>
    <div
      class="validation-container mt-2"
      *ngIf="
        fileUploadContent['fileUploadPercent'] === 100 && !showValidationError
      "
    >
      <img class="file-loading" src="/assets/images/file-loading.gif" />
      <div class="processing-label">Processing Validation</div>
    </div>
    <div
      class="validationError"
      *ngIf="
        fileUploadContent['fileUploadPercent'] === 100 && showValidationError
      "
    >
      <app-file-validation
        [errorResponse]="validationData?.vilc"
        [isValidationSuccess]="validationData?.vilc?.status"
      ></app-file-validation>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <app-button-secondary
        (actionButtonCall)="onDialogClose()"
        buttonCaption="Cancel"
      ></app-button-secondary>
      <app-button-primary
        buttonCaption="Proceed"
        [loaderEnabledFlag]="showDialogLoader"
        [buttonDisabled]="buttonDisabled"
        (actionButtonCall)="editModifyProceed()"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>
<p-toast position="bottom-right" key="c">
  <ng-template let-message pTemplate="message">
    <app-message-popup [data]="message" style="width: 100%"></app-message-popup>
  </ng-template>
</p-toast>
<p-toast position="bottom-right" key="w"></p-toast>
